// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"37":"1db674f6b0b8c10f","107":"aa79a38347cdcecb","110":"281f4f2e0d40ccd3","953":"4d72d1c6db214237"}[chunkId] + ".js";
};